
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiFilter2On as ObiFilter2OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-filter-2-on.js';
 
 
 

 
 export const ObiFilter2On = createComponent({
   react: React,
   tagName: 'obi-filter-2-on',
   elementClass: ObiFilter2OnElement,
   events: {
     
   }
  });
 
 